import ServiceGraphQL from 'src/service/gql-service';
// import { sendCompanyInvitation } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const SendCompanyInvitation = (data) => {
  let query = 'mutation sendCompanyInvitation {';
  data.forEach((p, index) => {
    query += `invitation1: sendCompanyInvitation(emails: "${p.email}", role: "${p.role}"){
      email
      success
      error
    }${index === data.length - 1 ? '}' : ','}`;
  });
  const params = {
    // query: sendCompanyInvitation.QUERY,
    // variables: data
    query
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
